import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function ImportTranslationButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.import")}</ActionButtonLayout>;

}

export default ImportTranslationButtonLayout;

